/* Dedicated oil design: native Palo Alto cart/variants/zoom; scroll-snap gallery. */
(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-lpda-oil]').forEach((root) => {
      if (root.lpdaCleanup) root.lpdaCleanup();
      const abort = new AbortController();
      const listen = (target, event, handler, options = {}) => target?.addEventListener(event, handler, { ...options, signal: abort.signal });
      const track = root.querySelector('[data-gallery-track]');
      const thumbs = root.querySelector('[data-thumbs]');
      const buttons = [...root.querySelectorAll('[data-slide]')];
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let active = 0;
      const reflectSlide = () => {
        active = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        buttons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === active)));
        [...track.children].forEach((slide, index) => {
          slide.querySelector('a').tabIndex = index === active ? 0 : -1;
        });
      };
      const go = (index, behavior = reduced.matches ? 'auto' : 'smooth') => {
        track.scrollTo({ left: Math.max(0, Math.min(buttons.length - 1, index)) * track.clientWidth, behavior });
      };
      thumbs.hidden = false;
      buttons.forEach(button => listen(button, 'click', () => go(Number(button.dataset.slide))));
      listen(track, 'scroll', reflectSlide, { passive: true });
      listen(track, 'keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        go(event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : active + (event.key === 'ArrowRight' ? 1 : -1));
      });
      const resize = new ResizeObserver(() => go(active, 'instant'));
      resize.observe(track);
      reflectSlide();

      const info = root.querySelector('product-info');
      const formWrapper = info.querySelector('product-form');
      const form = formWrapper.querySelector('form');
      const syncPurchase = () => {
        const button = info.querySelector('[data-add-to-cart]');
        const unavailable = formWrapper.classList.contains('variant--soldout') || formWrapper.classList.contains('variant--unavailable');
        if (unavailable && !button.disabled) button.disabled = true;
        const label = info.querySelector('[data-add-to-cart-text]').textContent;
        const busy = button.classList.contains('is-loading');
        root.querySelectorAll('[data-buy]').forEach(mirror => {
          mirror.disabled = button.disabled || busy;
          mirror.setAttribute('aria-busy', String(busy));
          if (mirror.textContent !== label) mirror.textContent = label;
        });
        const price = info.querySelector('[data-product-price]').textContent;
        root.querySelectorAll('[data-price]').forEach(mirror => { if (mirror.textContent !== price) mirror.textContent = price; });
      };
      const purchaseObserver = new MutationObserver(syncPurchase);
      purchaseObserver.observe(info, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class'] });
      syncPurchase();
      let unsubscribe;
      if (typeof window.subscribe === 'function' && window.theme?.PUB_SUB_EVENTS?.variantChange) {
        unsubscribe = window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== info.dataset.section) return;
          info.querySelector('[data-add-to-cart]').disabled = !data.variant?.available;
          const imageId = data.variant?.featured_image?.id;
          const index = [...track.children].findIndex(slide => slide.dataset.imageId === String(imageId));
          if (index >= 0) go(index);
          syncPurchase();
        });
      }
      const composition = root.querySelector('details[id^="huile-inci-"]');
      const openComposition = () => { if (window.location.hash === '#' + composition.id) composition.open = true; };
      listen(window, 'hashchange', openComposition);
      openComposition();

      const sticky = root.querySelector('[data-sticky]');
      const finale = root.querySelector('[data-final]');
      let frame = 0;
      const updateSticky = () => {
        frame = 0;
        if (sticky) sticky.hidden = !(form.getBoundingClientRect().bottom <= 0 && finale.getBoundingClientRect().top >= window.innerHeight && root.getBoundingClientRect().bottom > 0);
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(updateSticky); };
      listen(window, 'scroll', schedule, { passive: true });
      listen(window, 'resize', schedule, { passive: true });
      listen(document, 'shopify:section:unload', event => { if (event.target.contains(root)) root.lpdaCleanup(); });
      root.lpdaCleanup = () => {
        abort.abort(); resize.disconnect(); purchaseObserver.disconnect(); unsubscribe?.();
        if (frame) cancelAnimationFrame(frame);
        if (sticky) sticky.hidden = true;
      };
      updateSticky();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
